export const BACKEND_KEYS = {
    PHP: 'php',
    NODE: 'node',
};

export const MODULE_BACKEND_ROUTING = {
    firmas: { defaultBackend: BACKEND_KEYS.PHP, fallbackOrder: [BACKEND_KEYS.PHP], endpoints: {} },
    auth: {
        defaultBackend: BACKEND_KEYS.PHP,
        fallbackOrder: [BACKEND_KEYS.PHP],
        endpoints: {
            login: { path: '/react-auth/login', backends: [BACKEND_KEYS.PHP] },
            refresh: { path: '/react-auth/refresh', backends: [BACKEND_KEYS.PHP] },
            me: { path: '/react-auth/me', backends: [BACKEND_KEYS.PHP] },
            logout: { path: '/react-auth/logout', backends: [BACKEND_KEYS.PHP] },
            menu: { path: '/react-auth/menu', backends: [BACKEND_KEYS.PHP] },
        },
    },
    dashboard: {
        defaultBackend: BACKEND_KEYS.PHP,
        fallbackOrder: [BACKEND_KEYS.PHP, BACKEND_KEYS.NODE],
        endpoints: {
            technicalSummary: { path: '/react/dashboard/tecnico/resumen', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
        },
    },
    perfil: {
        defaultBackend: BACKEND_KEYS.PHP,
        fallbackOrder: [BACKEND_KEYS.PHP, BACKEND_KEYS.NODE],
        endpoints: {
            summary: { path: '/react/perfil/resumen', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            password: { path: '/react/perfil/password', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            passwordInicial: { path: '/react/perfil/password-inicial', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            pinFirma: { path: '/react/perfil/pin-firma', backends: [BACKEND_KEYS.PHP] },
            contacto: { path: '/react/perfil/contacto', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            twoFactorEnable: { path: '/react/perfil/2fa/enable', backends: [BACKEND_KEYS.PHP] },
            twoFactorConfirm: { path: '/react/perfil/2fa/confirm', backends: [BACKEND_KEYS.PHP] },
            twoFactorDisable: { path: '/react/perfil/2fa/disable', backends: [BACKEND_KEYS.PHP] },
            twoFactorRegenerateCodes: { path: '/react/perfil/2fa/recovery-codes/regenerate', backends: [BACKEND_KEYS.PHP] },
            firma: { path: '/react/perfil/firma', backends: [BACKEND_KEYS.PHP] },
        },
    },
    credenciales: {
        defaultBackend: BACKEND_KEYS.PHP,
        fallbackOrder: [BACKEND_KEYS.PHP, BACKEND_KEYS.NODE],
        endpoints: {
            mine: { path: '/react/credenciales/mis', backends: [BACKEND_KEYS.PHP, BACKEND_KEYS.NODE] },
            download: { path: '/react/credenciales/{id}/download', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
        },
    },
    notificaciones: {
        defaultBackend: BACKEND_KEYS.PHP,
        fallbackOrder: [BACKEND_KEYS.PHP],
        endpoints: {
            list: { path: '/react/notificaciones', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            create: { path: '/react/notificaciones/crear', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            markRead: { path: '/react/notificaciones/{id}/leer', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            markAllRead: { path: '/react/notificaciones/leer-todas', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
        },
    },
    push: {
        defaultBackend: BACKEND_KEYS.NODE,
        fallbackOrder: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP],
        endpoints: {
            register: { path: '/react/push/devices', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            unregister: { path: '/react/push/devices/unregister', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
        },
    },
    errorReports: {
        defaultBackend: BACKEND_KEYS.PHP,
        fallbackOrder: [BACKEND_KEYS.PHP],
        endpoints: {
            create: { path: '/react/error-reports', backends: [BACKEND_KEYS.PHP] },
        },
    },
    tracking: {
        defaultBackend: BACKEND_KEYS.NODE,
        fallbackOrder: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP],
        endpoints: {
            storeLocation: { path: '/tracking/location', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            batchLocation: { path: '/tracking/batch', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            teamLocations: { path: '/tracking/team-locations', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            lastLocation: { path: '/tracking/last-location', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
        },
    },
    visitas: {
        defaultBackend: BACKEND_KEYS.PHP,
        fallbackOrder: [BACKEND_KEYS.PHP, BACKEND_KEYS.NODE],
        endpoints: {
            list: { path: '/react/visitas', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            detail: { path: '/react/visitas/{id}/detalle', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            status: { path: '/react/visitas/{id}/estado-actual', backends: [BACKEND_KEYS.PHP] },
            editContext: { path: '/react/visitas/{id}/edit-context', backends: [BACKEND_KEYS.PHP] },
            // Importante: el autosave React usa diff payload con observacion/estado_sistema y merge por clave.
            // Debe pasar por el guard JWT de React para evitar 401 cuando no hay sesion web.
            autosave: { path: '/react/visitas/{id}/autosave', backends: [BACKEND_KEYS.PHP] },
            // CRITICO: usar PHP para mantener paridad exacta de indices/sufijos en subgrupos.
            // La implementacion Node no replica toda la logica de addGroup (multiplier/base, reuse, etc.).
            addGroup: { path: '/react/visitas/{id}/add-group', backends: [BACKEND_KEYS.PHP] },
            dividirTrabajo: { path: '/react/visitas/{id}/dividir-trabajo', backends: [BACKEND_KEYS.PHP] },
            finalizarMiSeccion: { path: '/react/visitas/{id}/finalizar-mi-seccion', backends: [BACKEND_KEYS.PHP] },
            removeGroupInstance: { path: '/react/visitas/{id}/remove-group-instance', backends: [BACKEND_KEYS.PHP] },
            uploadImage: { path: '/react/visitas/{id}/imagenes', backends: [BACKEND_KEYS.PHP] },
            deleteImage: { path: '/react/visitas/{id}/imagenes/delete', backends: [BACKEND_KEYS.PHP] },
            reorderImages: { path: '/react/visitas/{id}/imagenes/reorder', backends: [BACKEND_KEYS.PHP] },
            uploadDocumentation: { path: '/react/visitas/{id}/documentacion', backends: [BACKEND_KEYS.PHP] },
            deleteDocumentation: { path: '/react/visitas/{id}/documentacion/delete', backends: [BACKEND_KEYS.PHP] },
            saveObservacionesCorrectivas: { path: '/react/visitas/{id}/observaciones-correctivas', backends: [BACKEND_KEYS.PHP] },
            catalogBySucursal: { path: '/activos/sucursal/{sucursalId}', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            catalogAllByUser: { path: '/activos/mis-sucursales', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            resolveActivoQr: { path: '/react/activos/resolve-qr', backends: [BACKEND_KEYS.PHP] },
            toggleInstance: { path: '/react/visitas/{id}/toggle-instance', backends: [BACKEND_KEYS.PHP] },
            updateField: { path: '/visitas/{id}/response-key', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            updateState: { path: '/react/visitas/{id}/estado', backends: [BACKEND_KEYS.PHP] },
            finish: { path: '/react/visitas/{id}/finalizar', backends: [BACKEND_KEYS.PHP] },
            reportPreview: { path: '/react/visitas/{id}/informe-preview', backends: [BACKEND_KEYS.PHP] },
            prepareControl: { path: '/react/visitas/{id}/para-control', backends: [BACKEND_KEYS.PHP] },
            pdf: { path: '/react/visitas/{id}/pdf', backends: [BACKEND_KEYS.PHP] },
            comprobantes: { path: '/react/visitas/{id}/comprobantes', backends: [BACKEND_KEYS.PHP] },
            updateReportBody: { path: '/react/visitas/{id}/informe-body', backends: [BACKEND_KEYS.PHP] },
            restoreReportBody: { path: '/react/visitas/{id}/informe-body/restore', backends: [BACKEND_KEYS.PHP] },
            precloseAudit: { path: '/react/visitas/{id}/preclose-audit', backends: [BACKEND_KEYS.PHP] },
        },
    },
    mangueras: {
        defaultBackend: BACKEND_KEYS.PHP,
        fallbackOrder: [BACKEND_KEYS.PHP],
        endpoints: {
            list: { path: '/react/mangueras/ciclos', backends: [BACKEND_KEYS.PHP] },
            detail: { path: '/react/mangueras/ciclos/{id}', backends: [BACKEND_KEYS.PHP] },
            planning: { path: '/react/mangueras/ciclos/{id}/planificacion', backends: [BACKEND_KEYS.PHP] },
            scheduleDelivery: { path: '/react/mangueras/ciclos/{id}/programar-entrega', backends: [BACKEND_KEYS.PHP] },
            approve: { path: '/react/mangueras/ciclos/{id}/items/{itemId}/aprobar', backends: [BACKEND_KEYS.PHP] },
            reject: { path: '/react/mangueras/ciclos/{id}/items/{itemId}/rechazar', backends: [BACKEND_KEYS.PHP] },
            returnToWorkshop: { path: '/react/mangueras/ciclos/{id}/items/{itemId}/volver-a-taller', backends: [BACKEND_KEYS.PHP] },
            recalculate: { path: '/react/mangueras/ciclos/{id}/recalcular', backends: [BACKEND_KEYS.PHP] },
            close: { path: '/react/mangueras/ciclos/{id}/cerrar', backends: [BACKEND_KEYS.PHP] },
        },
    },
    portalInformes: {
        defaultBackend: BACKEND_KEYS.PHP,
        fallbackOrder: [BACKEND_KEYS.PHP],
        endpoints: {
            list: { path: '/react/informes', backends: [BACKEND_KEYS.PHP] },
            filters: { path: '/react/informes/filtros', backends: [BACKEND_KEYS.PHP] },
            document: { path: '/react/informes/{id}/documento', backends: [BACKEND_KEYS.PHP] },
            pdf: { path: '/react/informes/{id}/documento.pdf', backends: [BACKEND_KEYS.PHP] },
        },
    },
    portalSolicitudes: {
        defaultBackend: BACKEND_KEYS.PHP,
        fallbackOrder: [BACKEND_KEYS.PHP],
        endpoints: {
            list: { path: '/react/solicitudes', backends: [BACKEND_KEYS.PHP] },
            filters: { path: '/react/solicitudes/filtros', backends: [BACKEND_KEYS.PHP] },
            detail: { path: '/react/solicitudes/{id}', backends: [BACKEND_KEYS.PHP] },
            store: { path: '/react/solicitudes', backends: [BACKEND_KEYS.PHP] },
            update: { path: '/react/solicitudes/{id}', backends: [BACKEND_KEYS.PHP] },
            attachment: { path: '/react/solicitudes/{id}/adjuntos/{tipo}/{indice}', backends: [BACKEND_KEYS.PHP] },
        },
    },
    portalActivos: {
        defaultBackend: BACKEND_KEYS.PHP,
        fallbackOrder: [BACKEND_KEYS.PHP],
        endpoints: {
            export: { path: '/react/activos-tecnicos/exportar', backends: [BACKEND_KEYS.PHP] },
            list: { path: '/react/activos-tecnicos', backends: [BACKEND_KEYS.PHP] },
            filters: { path: '/react/activos-tecnicos/filtros', backends: [BACKEND_KEYS.PHP] },
            detail: { path: '/react/activos-tecnicos/{id}', backends: [BACKEND_KEYS.PHP] },
            document: { path: '/react/activos-tecnicos/{id}/documentacion/{documentId}', backends: [BACKEND_KEYS.PHP] },
        },
    },
    activosTecnicos: {
        // La presentación externa usa portalActivos y una única autorización en Laravel.
        defaultBackend: BACKEND_KEYS.NODE,
        fallbackOrder: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP],
        endpoints: {
            list: { path: '/react/activos-tecnicos', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            filters: { path: '/react/activos-tecnicos/filtros', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            detail: { path: '/react/activos-tecnicos/{id}', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            create: { path: '/react/activos-tecnicos', backends: [BACKEND_KEYS.NODE] },
            update: { path: '/react/activos-tecnicos/{id}', backends: [BACKEND_KEYS.NODE] },
            changeStatus: { path: '/react/activos-tecnicos/{id}/estado', backends: [BACKEND_KEYS.NODE] },
            delete: { path: '/react/activos-tecnicos/{id}', backends: [BACKEND_KEYS.NODE] },
            restore: { path: '/react/activos-tecnicos/{id}/restaurar', backends: [BACKEND_KEYS.NODE] },
            stats: { path: '/react/activos-tecnicos/estadisticas', backends: [BACKEND_KEYS.NODE] },
            reorder: { path: '/react/activos-tecnicos/ordenar', backends: [BACKEND_KEYS.NODE] },
            export: { path: '/react/activos-tecnicos/exportar', backends: [BACKEND_KEYS.NODE] },
            latestInspection: { path: '/react/activos-tecnicos/informe-ultima-inspeccion', backends: [BACKEND_KEYS.NODE] },
            bulkQr: { path: '/react/activos-tecnicos/qr-masivo', backends: [BACKEND_KEYS.NODE] },
            linkable: { path: '/react/activos-tecnicos/vinculables', backends: [BACKEND_KEYS.NODE] },
            prepareCreate: { path: '/react/activos-tecnicos/preparar-alta', backends: [BACKEND_KEYS.NODE] },
            generateBatch: { path: '/react/activos-tecnicos/generar-lote', backends: [BACKEND_KEYS.NODE] },
            requests: { path: '/react/activos-tecnicos/solicitudes', backends: [BACKEND_KEYS.NODE] },
            createRequest: { path: '/react/activos-tecnicos/{id}/solicitudes', backends: [BACKEND_KEYS.NODE] },
            approveRequest: { path: '/react/activos-tecnicos/solicitudes/{requestId}/aprobar', backends: [BACKEND_KEYS.NODE] },
            rejectRequest: { path: '/react/activos-tecnicos/solicitudes/{requestId}/rechazar', backends: [BACKEND_KEYS.NODE] },
            storeAttachment: { path: '/react/activos-tecnicos/{id}/adjuntos', backends: [BACKEND_KEYS.NODE] },
            deleteAttachment: { path: '/react/activos-tecnicos/{id}/adjuntos/{attachmentId}', backends: [BACKEND_KEYS.NODE] },
            qr: { path: '/react/activos-tecnicos/{id}/qr', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            qrPdf: { path: '/react/activos-tecnicos/{id}/qr-pdf', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            geolocalize: { path: '/react/activos-tecnicos/{id}/geolocalizar', backends: [BACKEND_KEYS.PHP] },
        },
    },
    procesadoTaller: {
        defaultBackend: BACKEND_KEYS.PHP,
        fallbackOrder: [BACKEND_KEYS.PHP],
        endpoints: {
            dashboard: { path: '/react/procesado-taller', backends: [BACKEND_KEYS.PHP] },
            filters: { path: '/react/procesado-taller/filtros', backends: [BACKEND_KEYS.PHP] },
            ingresoOptions: { path: '/react/procesado-taller/ingreso/opciones', backends: [BACKEND_KEYS.PHP] },
            ingresar: { path: '/react/procesado-taller/ingreso', backends: [BACKEND_KEYS.PHP] },
            prepareProcessing: { path: '/react/procesado-taller/activos/{id}/procesado', backends: [BACKEND_KEYS.PHP] },
            process: { path: '/react/procesado-taller/activos/{id}/procesado', backends: [BACKEND_KEYS.PHP] },
            confirm: { path: '/react/procesado-taller/ciclos/{id}/confirmar-coordinacion', backends: [BACKEND_KEYS.PHP] },
            certificate: { path: '/react/procesado-taller/verificados/{id}/certificado', backends: [BACKEND_KEYS.PHP] },
        },
    },
    informes: {
        defaultBackend: BACKEND_KEYS.NODE,
        fallbackOrder: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP],
        endpoints: {
            list: { path: '/react/informes', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            filters: { path: '/react/informes/filtros', backends: [BACKEND_KEYS.PHP] },
            ultimaInspeccion: { path: '/react/informes/ultima-inspeccion', backends: [BACKEND_KEYS.PHP] },
            preview: { path: '/react/informes/{id}/preview', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            pdf: { path: '/react/informes/{id}/pdf', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            observacionGeneral: { path: '/react/informes/{id}/observacion-general', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
        },
    },
    observaciones: {
        defaultBackend: BACKEND_KEYS.PHP,
        fallbackOrder: [BACKEND_KEYS.PHP],
        endpoints: {
            list: { path: '/react/observaciones', backends: [BACKEND_KEYS.PHP] },
            filters: { path: '/react/observaciones/filtros', backends: [BACKEND_KEYS.PHP] },
            store: { path: '/react/observaciones', backends: [BACKEND_KEYS.PHP] },
            update: { path: '/react/observaciones/{id}', backends: [BACKEND_KEYS.PHP] },
            aprobarPresupuesto: { path: '/react/observaciones/{id}/aprobar-presupuesto', backends: [BACKEND_KEYS.PHP] },
            rechazarPresupuesto: { path: '/react/observaciones/{id}/rechazar-presupuesto', backends: [BACKEND_KEYS.PHP] },
            presupuesto: { path: '/react/observaciones/{id}/presupuesto', backends: [BACKEND_KEYS.PHP] },
            pdf: { path: '/react/observaciones/{id}/pdf', backends: [BACKEND_KEYS.PHP] },
        },
    },
    solicitudes: {
        defaultBackend: BACKEND_KEYS.NODE,
        fallbackOrder: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP],
        endpoints: {
            list: { path: '/react/solicitudes', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            filters: { path: '/react/solicitudes/filtros', backends: [BACKEND_KEYS.PHP] },
            store: { path: '/react/solicitudes', backends: [BACKEND_KEYS.PHP] },
            update: { path: '/react/solicitudes/{id}', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            aprobar: { path: '/react/solicitudes/{id}/aprobar', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
            rechazar: { path: '/react/solicitudes/{id}/rechazar', backends: [BACKEND_KEYS.NODE, BACKEND_KEYS.PHP] },
        },
    },
};
